import type { IconData } from '@stacksjs/iconify-core'

export const toggleOff: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M368 128H144a128 128 0 0 0 0 256h224a128 128 0 0 0 0-256m0 224H144a96 96 0 0 1 0-192h224a96 96 0 0 1 0 192\"/><path fill=\"currentColor\" d=\"M144 192a64 64 0 1 0 64 64a64.07 64.07 0 0 0-64-64m0 96a32 32 0 1 1 32-32a32.036 32.036 0 0 1-32 32\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default toggleOff
